import React from 'react'

const StepHeader = ({ step, actionText }) => {
  const getStepTitle = () => {
    switch (step) {
      case 1:
        return `Approve ${actionText} Transaction`
      case 2:
        return `Review Gas Fees`
      case 3:
        return `Confirm ${actionText}`
      case 4:
        return `${actionText} Successful`
      default:
        return ''
    }
  }

  return (
    <div className="d-flex align-items-center justify-content-between">
      <span style={{ color: 'var(--text-primary)' }}>{getStepTitle()}</span>
      {step < 4 && (
        <span className="ms-2 badge bg-light text-dark border">
          Step {step} of 3
        </span>
      )}
    </div>
  )
}

export default StepHeader
